import styled, { css } from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const StyledViewByDevice = styled.div`
  display: none;
  min-height: ${({ minH = 'auto' }) => minH};
  ${({ variant }) =>
    variant === 'mobile'
      ? css`
          ${respondTo.mobile`
      display: flex !important;
      flex: ${({ mbFlex = 1 }) => mbFlex};
      width: 100%;
    `}
          ${respondTo.desktop`
      display: none !important;
    `}
        `
      : css`
          ${respondTo.mobile`
          
      display: ${({ forceShow = false }) =>
        forceShow ? 'flex' : 'none'} !important;
    `}
          ${respondTo.desktop`
        display: flex !important;
        flex: ${({ descFlex = 1 }) => descFlex};
        width: 100%;
    `}
        `}
`;
